/**
 * Класс-обёртка для {@link ReadonlyMap} с возможностью задать значение по умолчанию
 */
export class ConvertingMap<K, V> {
    private readonly convertingMap: ReadonlyMap<K, V>;

    private readonly defaultValue: V;

    constructor(entries: [K, V][], defaultValue?: V) {
        this.convertingMap = new Map<K, V>(entries);
        this.defaultValue = defaultValue;
    }

    convert = (key: K): V => {
        if (this.convertingMap.has(key)) {
            return this.convertingMap.get(key);
        }
        if (this.defaultValue !== undefined) {
            return this.defaultValue;
        } else {
            throw Error(
                `There is no suitable value presented for key: ${key} and defaultValue doesn't set up`,
            );
        }
    };
}
